const emptyHTMLString = "<p>&nbsp;</p>";

export const validateEventReservationSettingsForm = (data) => {
  const errors = {};
  if (!data.eventSettings?.maxPaxSelection) {
    errors.maxPaxSelection = "Max pax selection is required.";
  } else if (data.eventSettings.maxPaxSelection <= 0) {
    errors.maxPaxSelection = "Max pax selection must at least 1.";
  }
  if (
    !data.eventSettings?.reservationDescription?.trim() ||
    data.eventSettings.reservationDescription === emptyHTMLString
  ) {
    errors.reservationDescription = "Reservation description is required.";
  }
  return errors;
};

export const validateEventReservationTimeSlotSettingsForm = (data) => {
  const errors = {};
  if (!data.slotTitle?.trim()) {
    errors.slotTitle = "Slot title is required.";
  }
  if (!data.slotStatus?.trim()) {
    errors.slotStatus = "Slot status is required.";
  }
  if (!data.maxPax) {
    errors.maxPax = "Max pax is required.";
  } else if (data.maxPax <= 0) {
    errors.maxPax = "Max pax must at least 1.";
  }
  if (!data.startTime?.trim()) {
    errors.startTime = "Start time is required.";
  }
  if (!data.endTime?.trim()) {
    errors.endTime = "End time is required.";
  }
  if (!data.eventDate?.trim()) {
    errors.eventDate = "Event date is required.";
  }
  return errors;
};
